<div class="container">
    <div class="card">
        
        <div  *ngIf="!isTask ">
            <div class="task-head">
                <h4 *ngIf="!data?.isFeedTask">Success!</h4>
                <div *ngIf="data?.isFeedTask" class="feed-task-heading">
                  <h4>Answer Budget</h4>
                  <img
                    width="17px"
                    height="17px"
                    [src]="tooltipImagePath"
                    matTooltip="The choice decides between the speed of data acquisition and the cost of the data to answer the question within the generated budget."
                    matTooltipClass="custom-option-tooltip"
                    alt="Budget info"
                  />
                </div>
            </div>
            <p *ngIf="data?.data?.budget && isBudgetEqual && !data?.pointUser">Generated budget : {{data.data.budget[0].minRange | currencyFormat}}</p>
            <p *ngIf="data?.data?.budget && !isBudgetEqual && !data?.pointUser">Generated budget : {{data.data.budget[0].minRange | currencyFormat}} - {{data.data.budget[0].maxRange | currencyFormat}}</p>

            <p *ngIf="data?.data?.budget && isBudgetEqual && data?.pointUser">Generated budget : {{data.data.budgetPoints[0].minPointRange}} points</p>
            <p *ngIf="data?.data?.budget && !isBudgetEqual && data?.pointUser">Generated budget : {{data.data.budgetPoints[0].minPointRange}} points - {{data.data.budgetPoints[0].maxPointRange}} points</p>

          <div [formGroup]="formGroup" class="task-text" *ngIf="!data?.isFeedTask">
            <div class="align form-lble">
              <label class="form-label">Budget Name<span>*</span></label>
              <input matInput type="name" formControlName="budgetName"  placeholder="Your budget name"
              maxlength="25" #inputField  (focus)="onFocus('budgetName')"  (input)="onFocusOrInput()" (blur)="onBlur()"  tabindex="-1"/>
           
                
          
            <div class="error-container">
              <mat-error *ngIf="formGroup.get('budgetName').hasError('required') && formGroup.get('budgetName').touched" class="error-messages">
                Budget Name is required
              </mat-error>
              <mat-error *ngIf="formGroup.get('budgetName').hasError('minlength') && formGroup.get('budgetName').touched" class="error-messages">
                At least 5 characters long
              </mat-error>
              <mat-error *ngIf="formGroup.get('budgetName').hasError('maxlength') && formGroup.get('budgetName').touched" class="error-messages">
                Maximum 25 characters long
              </mat-error>
            </div>
          </div>
          <!-------------------------------site name div ---------------------------->
          <div *ngIf="data.rfSignals && !isBroRF()" class="rfClass">
            <div class="card">
              <!-- <div class="task-head">
                <h4>Required!</h4>
              </div> -->

              <div class="icon">
                <p class="para">
                  Please enter the sitename (s).
                </p>

                <img style="margin-top: -38px; margin-left: 230px; padding-right: 3px;" width="20px" height="20"
                matTooltip="A site name is a distinct name such as a known landfill name or a mine name." [src]="tooltipImagePath"/>
              </div>
            </div>
            <div class="popup-container">
              <form class="form-vertical1" fxLayout="column" fxLayoutGap="10px" [formGroup]="rfFormGroup">
                <div class="formDetails" style=" width: 100%;">
                  <div style="margin: 0 25%">
                  <label class="siteName">Site Id<span>*</span></label>
                  <label class="siteId">Site Name<span>*</span></label></div>
                  <div class="left scrollbar" id="scrollcustom" style="margin: 0 25%">
                    <div *ngFor="let point of data.targetInMap; let i = index">
                      <div class="input-container" fxLayout="row" fxLayoutGap="20px">
                        <input type="text" [value]="i+1" readonly />
                        <div style="display: flex;align-items: center;">
                          <input type="name" placeholder="Your site name" [id]="'sitename-' + i"
                          [formControlName]="'sitename-' + i"
                          required (keydown)="Space($event)" maxlength="25" class="siteNameInput"/>
                          <span style="padding-left: 10px;" [matTooltipClass]="'target-tooltip'"               
                          matTooltip="{{point}}">
                            <img width="18px" height="18" [src]="tooltipImagePath">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <p class="para" style="padding-top: 15px;">
                    Please enter the number of collections required for the time of interest (TOI).
                  </p>

                  <mat-form-field appearance="outline" class="options">
                    <input matInput formControlName="daysCount" placeholder="Number of collections" class="matOption matOptionNumber" type="number" #inputField/>
                  </mat-form-field>
                  <div class="error-message" style=" margin-bottom: 20px !important;" *ngIf="fetchError && fetchMessage">
                    {{this.fetchMessage}}
                  </div>
                </div> -->
              </form>
            </div>
          </div>
        <!-- </div> -->
          <!-------------------------------site name div end---------------------------->
        </div>
        </div>
        <div *ngIf="isTask && !data?.isFeedTask" >
          <div class="task-head">
            <h4>Required!</h4>
        </div>
          <div [formGroup]="formTaskGroup" class="task-text">
            
              <div class="align form-lble">
                  <label class="form-label">Project Name<span>*</span></label>
                      <input  maxlength="25" type="name" matInput placeholder="Your project name" (keyup)="nameChng($event, 1)"  
                      formControlName="project" (keydown)="Space($event)"   (focus)="onFocusProject('project')" tabindex="-1"/>
                      <div class="error-container">
                        <mat-error *ngIf="formTaskGroup?.get('project').hasError('required') && formTaskGroup?.get('project').touched" class="error-messages">Project
                          Name is required</mat-error>
                        <mat-error *ngIf="formTaskGroup?.get('project').hasError('minlength')&& formTaskGroup?.get('project').touched" class="error-messages">At
                          least 5 characters long</mat-error>
                        <mat-error *ngIf="formTaskGroup?.get('project').hasError('maxlength')&& formTaskGroup?.get('project').touched"
                        class="error-messages">Maximum 25 characters long</mat-error>
                      </div>
              </div>
              
              <div class="align form-lble">
                  <label class="form-label">Task Name<span>*</span></label>
                      <input matInput type="name" (keyup)="nameChng($event, 2)" placeholder="Your task name" formControlName="taskname"
                      (keydown)="Space($event)" maxlength="35" (focus)="onFocusProject('taskname')"  tabindex="-1"/>
                      <div class="error-container">
                        <mat-error *ngIf="formTaskGroup?.get('taskname').hasError('required') && formTaskGroup?.get('taskname').touched" class="error-messages">Task
                          Name is required</mat-error>
                        <mat-error *ngIf="formTaskGroup?.get('taskname').hasError('minlength')&& formTaskGroup?.get('taskname').touched" class="error-messages">At
                          least 5 characters long</mat-error>
                        <mat-error *ngIf="formTaskGroup?.get('taskname').hasError('maxlength')&& formTaskGroup?.get('taskname').touched"
                        class="error-messages">Maximum 35 characters long</mat-error>
                </div>
              </div>
          </div>
      </div>

        <div class="btns">
          <button class="custom-button " (click)="onNoClick('cancel')" *ngIf="isTask" >Cancel</button>
            <button class="custom-button " (click)="onNoClick('close')" *ngIf="!isTask" >Ok,Thanks</button>
            <button class="custom-button" (click)="onNoClick('save')" mat-flat-button
            [disabled]="!isBudgetNameFocusedOrHasValue || isSaveClicked || resetButton || isSaveButtonDisabled() || fetchError" *ngIf="!isTask && !data?.isFeedTask"  [ngClass]="{' budget-button': isBudgetNameFocusedOrHasValue}"> Save</button>
            <button class="custom-button budget-button" (click)="onNoClick(data?.isFeedTask ?'feed_task' : 'task')" *ngIf="!isTask" mat-flat-button
            [disabled]="(data?.currentUser?.permission_based && !data?.currentUser?.permissions.includes(1)) || isSaveButtonDisabled() || fetchError">Task</button>
            <button mat-flat-button [ngClass]="{'budget-button': !isBudgetNameFocusedOrHasValue, 'white-button': isBudgetNameFocusedOrHasValue}"  class="custom-button  budget-button"  (click)="onNoClick('save_task')" *ngIf="isTask && !data?.isFeedTask"  [disabled]="!isFormTaskValid || isSaveClicked">Save</button>
        </div>
    </div>
</div>